/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-02-14 00:00:00
 *
 *******************************************************/
import _ from 'lodash';

import React, { Component } from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import Dot from 'src/assets/images/shopify-integration/Dot.svg';

type Props = {};
type ComposedProps = Props & WithI18nProps;

type State = {};

class ProgressBar extends Component<ComposedProps, State> {
  render() {
    const { i18n, step } = this.props;

    const STEPS = [
      i18n.translate('AdminHTML.ShopifyIntegration.ProgressBar.step1'),
      i18n.translate('AdminHTML.ShopifyIntegration.ProgressBar.step2'),
      i18n.translate('AdminHTML.ShopifyIntegration.ProgressBar.step3')
    ];

    return (
      <div className="progress-bar">
        {_.map(STEPS, (label, index) => {
          const checkingStep = index + 1;
          const active = checkingStep < step;
          const activating = checkingStep === step;

          return (
            <React.Fragment key={`progress-bar-${index}`}>
              <div
                className={`step-content ${active ? 'active' : ''} ${
                  activating ? 'activating' : ''
                }`}>
                <div className="number">{`${active ? '' : checkingStep}`}</div>
                <div className="label">{label}</div>
              </div>
              {checkingStep < STEPS.length && (
                <img
                  className={`separator ${active ? 'active' : ''}`}
                  src={Dot}
                  alt=""
                  width="62"
                  height="8"
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    );
  }
}

export default withI18n()(ProgressBar);
